import React, { useContext, useEffect, useState } from "react";
import {
  Typography,
  CardContent,
  Card,
  CardActions,
  CardMedia,
  Rating,
  Box,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Link from "next/link";
import { ProductResponse, ProductInfo } from "../../interfaces/product/product-best";
import Image from 'next/legacy/image';

interface Props {
  dataSet: {
    data: ProductResponse
  }
}

export default function Bestseller({ dataSet }: Props) {

  const [value, setValue] = React.useState<number | null>(4.5);

  function isEmpty(object:any) {
    for (const property in object) {
      return false;
    }
    return true;
  }

  const thumb = "/assets/images/thumbnail/thume8.png";

  if (typeof dataSet === "object" && dataSet !== null && "message" in dataSet) {
    return dataSet.message;
  }
  if (dataSet === null) {`  `
    return "";
  }



  return (
    <>
      <Grid container spacing={2} columns={12}>
        {(dataSet as unknown as ProductResponse[]).map((data : ProductResponse, idx: number) => (
          <Grid xs={3} md key={idx}>
            <Link
              href={{
                pathname: `/product/${data.product_slug as string}`,
                query: { store: data.store_id as string, id: data.product_id as string },
              }}
            >
              <Card className="product-card-best">
                  <Image 
                    src={data.product_thumbnail_image_url ? data.product_thumbnail_image_url : thumb} 
                    alt={'test'} 
                    width={150} 
                    height={120}
                    layout='responsive'
                    objectFit="cover"
                    // priority
                    style={{
                      width: "100%",
                      objectFit: 'cover',
                    }}
                    loading="lazy"
                    placeholder="empty"
                    blurDataURL={data.product_thumbnail_image_url ? data.product_thumbnail_image_url : thumb}
                  />
                <CardContent>
                  <Typography gutterBottom variant="h3" sx={{ mt: 1, mb: 1 }}>
                    {data.product_title}
                    {/* {(data.product_info_multilanguage as ProductInfo[]).map((dataTil) => {
                      if (dataTil.lang == 'th') {
                        return dataTil.product_title;
                      }
                    })} */}
                  </Typography>
                  <Box className="chip-discount">
                    {data.product_percentage_discount == 0 ? "" : "ส่วนลด"+data.product_percentage_discount+"%"} 
                  </Box>
                  <Typography
                    variant="h5"
                    className="txt-bold"
                    gutterBottom
                    color="secondary"
                  >
                    {/* ราคาสุทธิ ถ้าสินค้าไม่มี product_discounted_price แสดง product_normal_price */}
                    ฿{data.product_discounted_price == 0 ? data.product_normal_price.toLocaleString() : data.product_discounted_price.toLocaleString()}
                    <Box
                      sx={{
                        typography: "body1",
                        display: "inline-block",
                        textDecoration: "line-through",
                        pl: 1
                      }}
                      color="text.secondary"
                    >
                       {/* ราคาเต็ม ถ้าสินค้าไม่มี product_discounted_price ไม่แสดง */}
                       {data.product_discounted_price == 0 ? "" : "฿"+data.product_normal_price.toLocaleString()}
                    </Box>
                  </Typography>
                </CardContent>
                <CardActions
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  {/* <Rating
                    name="read-only"
                    value={value}
                    precision={0.5}
                    readOnly
                    size="small"
                    label={5}
                    sx={{ fontSize: 16 }}
                  /> */}
                  {/* <Typography variant="caption" sx={{ mr: 1, ml: 1 }}>
                    (15)
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    ขายแล้ว {data.product_sold} ชิ้น
                  </Typography> */}
                </CardActions>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
